import { Injectable, inject } from "@angular/core";
import { calculateDistanceBetweenTwoPoints, findGreatestDistanceObject, getEnabledCompareables } from "../helpers/compareable-helper";
import { EPSGType } from "../contract/Enum/EPSG";
import { Coordinate } from "../contract/Address/Coordinates";
import { Address } from "../contract/Address/Address";
import { ColorDefinition } from "../contract/Enum/Color";
import { MapLayer } from "../contract/Enum/MapLayer";
import { MarkerService } from "./marker.service";
import { PriceInformation } from "../contract/AVM/PriceInformation";
import { MapLayerService } from "./map-layer.service";

@Injectable({
  providedIn: "root"
})
export class PerimeterMarkerService {
  private readonly markerService = inject(MarkerService);
  private readonly mapLayerService = inject(MapLayerService);

  removePerimeterMarker() {
    this.mapLayerService.removeLayerByType(MapLayer.Perimeter);
  }

  setPerimeterMarker(address: Address, priceInformation: PriceInformation, isRent: boolean) {
    if (!address) {
      return;
    }
    const perimeterRadius = this.calculatePerimeterRadius(address, priceInformation, isRent);
    const defaultColorDefinition = new ColorDefinition();
    const coordinate = new Coordinate([Number(address.Coordinate.Longitude), Number(address.Coordinate.Latitude)], EPSGType.LonLat);
    if (perimeterRadius === 0) {
      this.mapLayerService.removeLayerByType(MapLayer.Perimeter);
      return;
    }
    this.mapLayerService.removeLayerByType(MapLayer.Perimeter);
    this.markerService.drawPerimeter(perimeterRadius, coordinate, defaultColorDefinition, 3, MapLayer.Perimeter);
  }

  private calculatePerimeterRadius(targetObject: Address, priceInformation: PriceInformation, isRent: boolean): number {
    const activatedCompareObjects = getEnabledCompareables(priceInformation, isRent);

    if (!activatedCompareObjects || activatedCompareObjects.length === 0) {
      return 0;
    }

    // Get center object coordinates
    const targetObjectCoordinates = new Coordinate([targetObject.Coordinate.Longitude, targetObject.Coordinate.Latitude], EPSGType.LonLat);

    // Find the compare object with the greatest distance from the target
    const greatestDistanceCompareObject = findGreatestDistanceObject(activatedCompareObjects, targetObjectCoordinates);

    // Get coordinates of the object with greatest distance
    const objectGreatestDistanceCoordinates = new Coordinate(
      [greatestDistanceCompareObject.Address.Coordinate.Longitude, greatestDistanceCompareObject.Address.Coordinate.Latitude],
      EPSGType.LonLat
    );

    // Calculate final perimeter radius
    const distanceBetween = calculateDistanceBetweenTwoPoints(targetObjectCoordinates, objectGreatestDistanceCoordinates);

    const perimaterRadius = distanceBetween + greatestDistanceCompareObject.PositionsInformation.Radius;
    return perimaterRadius;
  }
}
